import { render, staticRenderFns } from "./TitleScores.vue?vue&type=template&id=11499bf2&scoped=true&"
import script from "./TitleScores.vue?vue&type=script&lang=js&"
export * from "./TitleScores.vue?vue&type=script&lang=js&"
import style0 from "./TitleScores.vue?vue&type=style&index=0&id=11499bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11499bf2",
  null
  
)

/* custom blocks */
import block0 from "./TitleScores.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports